import React, { useState, useEffect, useCallback } from 'react';
import { makeStyles } from '@mui/styles';
import _ from 'underscore';
import moment from 'moment';
import { Page, Header, Alert } from 'components';
import { Autocomplete, CardContent, Grid as Grid2, TextField, Card, Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { SetSelectedSarpSites, GetSarpSites, GetSarpReport, GetSarpSiteTable, GetNopTrackerLastUpdate } from '../actions/SarpReportActions';
import SarpSiteTable from './SarpSiteTable';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	sitelist: {
		marginTop: theme.spacing(6),
	},
}));

const SarpReport = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const sarpSites = useSelector((state) => state.sarpReportReducer.sarpSites);
	const selectedSarpSites = useSelector((state) => state.sarpReportReducer.selectedSarpSites);
	const user = useSelector((state) => state.session.user);
	const sarpSiteTable = useSelector((state) => state.sarpReportReducer.sarpSiteTable);
	const lastNopTrackerUpdateDate = useSelector((state) => state.sarpReportReducer.lastNopTrackerUpdateDate);

	const _handleChange = (option) => {		
		dispatch(SetSelectedSarpSites(option));
	};

	const getData = useCallback(() => {
		dispatch(GetNopTrackerLastUpdate());
		dispatch(GetSarpSites());
		dispatch(GetSarpSiteTable());
	}, []);

	useEffect(() => {
		getData();
	}, []);

	const _generate = () => {
		const username = `${user.firstname} ${user.lastname}`;
		dispatch(GetSarpReport(selectedSarpSites, username, user.id));
	};

	return (
		<Page className={classes.root} title="Overview">
			<Header
				module="SARP"
				view="Reports"
			/>
			<Alert
				className={classes.container}
				variant="info"
				onClose={() => { }}
				message={'NOP Tracker last update: ' + `${moment(lastNopTrackerUpdateDate).format('DD-MM-YYYY HH:mm:SS').toString()}`}
			/>
			<Card className={classes.container}>
				<CardContent>					
					<Grid2 className={classes.container} container spacing={3}>
						<Grid2 item md={6} xs={12}>
							<SarpSiteTable className={classes.results} data={sarpSiteTable} />
						</Grid2>
					</Grid2>
					<Grid2 className={classes.container} container spacing={3}>
						<Grid2 item md={3}>							
							{selectedSarpSites.length > 0 ? <Button className={classes.generate} onClick={_generate} variant="contained">Generate</Button> : null}
						</Grid2>
					</Grid2>
				</CardContent>
			</Card>
		</Page>
	);
};

export default SarpReport;
